import { Box, IconButton, InputAdornment, Tooltip, Typography } from "@mui/material"
import { BaseInput } from "../../../../../../components"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../utils/icons"
import { InputCommentProps } from "./types"
import { useStyles } from "./styles"

const InputComment = ({ comment, show, isPending, setComment, sendComment }: InputCommentProps) => {
    const styles = useStyles()
    const { t } = useTranslation()
    if (!show) return null

    return (
        <Box sx={styles.comment}>
            <Typography variant="subtitle_grey" color='primary.100' fontWeight='bold'>{t('general.newComment')}</Typography>

            <BaseInput
                name="comment"
                value={{ comment: { label: t('general.comment'), value: comment } }}
                onChange={({ target: { value } }) => { setComment(value) }}
                multiline
                rows={3}
                maxRows={3}
                minRows={3}
                errors={{ comment: comment != null && comment?.length < 2 ? t('general.fieldRequired', { field: t('general.comment') }) : '' }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment sx={styles.addorment} position="end">
                            {/* <Tooltip title={t('general.addComment')}><IconButton disabled={isPending} onClick={sendComment} className={isPending ? '' : "color-delete"}>{icons('delete')}</IconButton></Tooltip> */}

                            <Tooltip title={t('general.addComment')}><IconButton disabled={isPending} onClick={sendComment} className={isPending ? '' : "color-primary"}>{icons('send')}</IconButton></Tooltip>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    )
}

export { InputComment }
